<template>
  <v-btn icon :title="title" v-on="$listeners" v-bind="$attrs">
    <v-icon color="primary">mdi-file-edit-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'EditIconButton',
  props: {
    title: {
      default () {
        return this.$t('general.edit');
      }
    }
  }
}
</script>
